import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=3d0f6e0c&lang=pug"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports